import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

type RulesPageFiltersCacheState = Record<string, DataItem[]>;

const initialState: RulesPageFiltersCacheState = {};

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.cache',
  initialState,
  reducers: {
    RESET_RULES_PAGE_FILTERS_CACHE: () => initialState,
    SET_RULES_PAGE_FILTERS_CACHE_BY_KEY: (
      state,
      action: PayloadAction<{
        key: keyof RulesPageFiltersCacheState;
        cache: DataItem[];
      }>,
    ) => {
      return {
        ...state,
        [action.payload.key]: action.payload.cache,
      };
    },
  },
});

export const selectorRulesPageFiltersCache = (state: RootState) => state.ipa.strategy.rules.filters.cache;

export const { RESET_RULES_PAGE_FILTERS_CACHE, SET_RULES_PAGE_FILTERS_CACHE_BY_KEY } = slice.actions;

export default slice.reducer;
